import { Input, Select, TextArea } from "..";
import "./ProjectInformation.scss";
import { useEffect, useState } from "react";
import {
  projInfo,
  projName,
  projType,
  projDesc,
  projTag,
  selectProjectTag,
  createNewProjectTag,
  SearchNewProjectTags,
  duplicateProjectNameError,
  projectNameRequiredError,
  projectTypes,
  projNameTooltip,
  projTypeTooltip,
  projDescTooltip,
  projTagsTooltip,
  projectNameRegexp,
  projectDescRegexp,
  projectNameLength,
  projectDescLength,
  maxLength100,
  maxLength4000,
  commonError,
  wafErrorMessage
} from "../../util/constants";
import {
  getDistinctProjectsNames,
  GetProjectDistinctTags,
} from "../../store/services/project.service";
import {
  setProjectName,
  setProjectType,
  setProjectDescrption,
  setProjectTags,
  setIsNextTabButtonDisabled,
  getLockingData,
} from "../../store/slices/projectSlice";
import MultiSelectCreatableOption from "../CommonUIComponents/MultiSelectCreatableOption";
import { useDispatch, useSelector } from "react-redux";
import { LockerModalM3 } from "../LockerModal";
import { Tooltip } from "../CommonUIComponents/Tooltip/Tooltip";
import { EmissionIcon } from "../../icons";
import { setWafErrorFlag } from "../../store/slices/projectSlice";

export function ProjectInformation({ onTabStepCompleted }) {
  const engagement = useSelector((state) => state.engagement.engagement);
  const project = useSelector((state) => state.project.project);
  const [projectNameErrorMessage, setProjectNameErrorMessage] = useState("");
  const [projectNameError, setProjectNameError] = useState(false);
  const [projectDescErrorMessage, setProjectDescErrorMessage] = useState("");
  const [avilableProjectTags, setAvilableTags] = useState([]);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [lockedData, setLock] = useState();
  const [lockedBy, setLockedby] = useState();
  const [isLockerModalOpen, setLockerModalOpen] = useState(false);
  const [nameChanged, setNameChanged] = useState(false);
  const initialName = project.projectName;

  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");

  useEffect(() => {
    if (wafErrorFlag) {
      setWafErrorMessageState(wafErrorMessage);
    }
  }, [wafErrorFlag]);

  useEffect(() => {
    async function GetProjectDistinctTagsFn() {
      const request = { engagementId: engagement.id };
      const data = await GetProjectDistinctTags({ request });
      setAvilableTags(data);
    }
    if (engagement?.id) {
      GetProjectDistinctTagsFn();
    }
  }, [engagement?.id, dispatch]);

  useEffect(() => {
    onTabStepCompleted();
    if (
      project.projectName &&
      project.projectType &&
      !projectNameErrorMessage &&
      !projectDescErrorMessage
    ) {
      dispatch(setIsNextTabButtonDisabled({ isDisabled: false }));
    } else {
      dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
    }
  });

  const handleOnChange = async (event, fieldName) => {
    dispatch(setWafErrorFlag(false));
    if (fieldName === "Project Name") {
      let error = "";
      let flag = false;
      if (event.target.value?.length >= maxLength100) {
        error = projectNameLength;
        setProjectNameErrorMessage(error);
        setProjectNameError(true);
        return;
      } else {
        setProjectNameErrorMessage("");
        setProjectNameError(false);
      }
      setNameChanged(event.target.value);
      dispatch(setProjectName({ name: event.target.value }));
      if (
        projectNameRegexp.test(event.target.value) &&
        event.target.value !== "-"
      ) {
        if (event.target.value === "") {
          error = projectNameRequiredError;
          flag = true;
        }
        setProjectNameErrorMessage(error);
        setProjectNameError(flag);
      } else {
        setProjectNameErrorMessage(commonError);
        setProjectNameError(true);
      }
    } else if (fieldName === "Project Type") {
      dispatch(setProjectType({ type: parseInt(event) }));
    } else if (fieldName === "Project Desc") {
      let error = "";
      if (event.target.value?.length > 4000) {
        error = projectDescLength;
        setProjectDescErrorMessage(error);
        return;
      } else {
        setProjectDescErrorMessage("");
      }
      dispatch(setProjectDescrption({ descrp: event.target.value }));
      if (
        event.target.value && !projectDescRegexp.test(event.target.value)
      ) {
        setProjectDescErrorMessage(commonError);
      } else if (event.target.value !== "-") {
        setProjectDescErrorMessage("");
      }
    } else if (fieldName === "Project Tags") {
      dispatch(setProjectTags({ tags: event }));
    }
  };

  const handlecheckIfProjectNameExist = async (event) => {
    if (!nameChanged) return;
    if (projectNameRegexp.test(project?.projectName)) {
      if (!project?.projectName?.trim()) {
        setProjectNameErrorMessage(projectNameRequiredError);
        setProjectNameError(true);
        dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
        return;
      };
      
      const data = await getDistinctProjectsNames({
        request: { engagementId: engagement.id },
      });
      const dataArray = data?.map((v) => v.trim()?.toLowerCase());
      const duplicateProjectName = dataArray?.includes(
        project?.projectName?.trim()?.toLowerCase()
      )
        ? true
        : false;
      setNameChanged(false);

      if (duplicateProjectName) {
        setProjectNameErrorMessage(duplicateProjectNameError);
        setProjectNameError(true);
        dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
      } else {
        setProjectNameErrorMessage("");
        setProjectNameError(false);
      }
    }
  };
  // to get a locked user flags
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (project.projectId) {
      const request = {
        LockedBy: user.username,
        ModuleName: "Project",
        EngagementID: project.projectId,
      };

      dispatch(getLockingData(request)).then((action) => {
        if (action) {
          const lockedData = action.payload?.data?.lockStatus;
          const lockedBy = action.payload?.data?.lockedBy;
          setLock(lockedData);
          setLockedby(lockedBy);
          if (lockedData === 2) {
            setLockerModalOpen(true);
          }
        }
      });
    }
  }, [dispatch]);
  /* eslint-enable react-hooks/exhaustive-deps */
  
  return (
    <div className="project-information">
      <div className="project-information-header">
        <span className="project-information-header-main">{projInfo}</span>
      </div>
      <div className="project-information-body">
        <div className="project-information-body-project">
          <div className="project-information-body-project-details">
            <span className="project-information-body-project-details-name">
              {projName}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={projNameTooltip}
              ></Tooltip>
            </span>
            <Input
              id="base-year-scope-1-2"
              label="Input"
              data-testid="M3Step1Name"
              type={"text"}
              onChange={(e) => handleOnChange(e, "Project Name")}
              onBlur={handlecheckIfProjectNameExist}
              errorMessage={projectNameErrorMessage}
              isError={projectNameError}
              value={project.projectName}
              disabled={lockedData === 1 && lockedBy !== user.username}
              className={"project-information-name-input"}
            />
            <span className="project-information-body-project-details-type">
              {projType}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={projTypeTooltip}
              ></Tooltip>
            </span>
            <Select
              id="base-year-scope-3"
              label="Input"
              onChange={(e) => {
                handleOnChange(e, "Project Type");
              }}
              value={project.projectType}
              options={projectTypes}
              disabled={
                project.projectId !== "" ||
                (lockedData === 1 &&
                  lockedBy !== user.username &&
                  project.projectId)
              }
            />
          </div>
          <div className="project-information-body-project-desc">
            <span className="project-information-body-project-desc-name">
              {projDesc}
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={projDescTooltip}
              ></Tooltip>
            </span>
            <TextArea
              id="base-year-scope-1-2"
              onChange={(e) => {
                handleOnChange(e, "Project Desc");
              }}
              value={project.projectDescrption}
              placeholder="Enter project description here"
              className={"project-information-body-project-desc-textarea"}
              disabled={
                lockedData === 1 &&
                lockedBy !== user.username &&
                project.projectId
              }
              errorMessage={projectDescErrorMessage}
              isError={projectDescErrorMessage}
            />
          </div>
          <div className="project-information-body-project-tags">
            <span className="project-information-body-project-tags-name">
              {projTag}
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={projTagsTooltip}
              ></Tooltip>
            </span>
            <div className="multiselectDiv">
              <MultiSelectCreatableOption
                value={project.projectTags}
                onChange={(e) => {
                  handleOnChange(e, "Project Tags");
                }}
                id="base-year-scope-1-2"
                avilableOptions={avilableProjectTags}
                label={selectProjectTag}
                overrideStrings={{
                  create: createNewProjectTag,
                  search: SearchNewProjectTags,
                }}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user.username &&
                  project.projectId
                }
                hasSelectAll={true}
                isCreatable={true}
              />
            </div>
          </div>
           {wafErrorFlag && <div className="waf-error-message">
              {wafErrorMessageState}
            </div>}
        </div>
      </div>
      {lockedData === 2 && lockedBy === user.username && project.projectId && (
        <LockerModalM3
          isOpen={isLockerModalOpen}
          onClose={() => setLockerModalOpen(false)}
        />
      )}
    </div>
  );
}
